import { Component, Input } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Rule } from '../rule';

@Component({
  selector: 'app-add-rule',
  templateUrl: './add-rule.component.html',
  styleUrl: './add-rule.component.scss',
  standalone: false
})
export class AddRuleComponent {

  public addruleGroup: FormGroup = this.fb.group({
    rules: this.fb.array([
      this.fb.group({
        metric: ['', [
          Validators.required
        ]],
        comparator: ['', [
          Validators.required
        ]],
        threshold: ['', [
          Validators.required,
          Validators.min(0),
          Validators.max(100)
        ]],
        interval: ['', [
          Validators.min(1)
        ]]
      })
    ], [this.uniqueArrayValidator()])
  });

  uniqueArrayValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const seen = new Set();
      let hasDuplicate = false;
  
      (control as FormArray).controls.forEach(ctrl => {

        const serialized = JSON.stringify(ctrl.value);
        if (seen.has(serialized)) {
          hasDuplicate = true;
        } else {
          seen.add(serialized);
        }
      });
  
      return hasDuplicate ? { 'duplicate': true } : null;
    };
  }

  public rulesFields = ["Metric", "Comparator", "Threshold", "Interval"];
  public metricOptions = ["1","2","3"];
  public metricOption = "";
  public comparatorOptions = [">", ">=", "=", "<=", "<"];
  public comparatorOption = "";
  public ruleDuplicationError: boolean = false;

  @Input() title: string = "Unnamed Rules";

  get rules(): FormArray {
    return this.addruleGroup.get("rules") as FormArray;
  }

  constructor(public languageService: LanguageService, private fb: FormBuilder) {
  }

  public getValue(element: any, key: any): string {
    return element[key];
  }

  addRule() {
    const rule = this.fb.group({
      metric: ['', [
        Validators.required
      ]],
      comparator: ['', [
        Validators.required
      ]],
      threshold: ['', [
        Validators.required
      ]],
      interval: ['', [
        Validators.required
      ]]
    });

    this.rules.push(rule);
  }

  removeRule(index: number) {
    this.rules.removeAt(index);
  }

  onKeypressEvent(e: any) {
  }

  isValid(): boolean {
    this.addruleGroup.markAllAsTouched();
    return this.addruleGroup.valid;
  }

  getRules(): Rule[]{
    const rulesArray: Rule[] = [];

    this.rules.controls.forEach(ruleElement => {
      const rule: Rule = { Metric: ruleElement.get("metric")?.value,
        Comparator: ruleElement.get("comparator")?.value,
        Threshold: ruleElement.get("threshold")?.value,
        Interval: ruleElement.get("interval")?.value
      } 
      
      rulesArray.push(rule);
    });

    return rulesArray;
  }
}
